import React, {useEffect, useState} from 'react';
import {Achievement} from "types/Achievement";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import {useNotifications} from "context/NotificationContext";
import ngage from "services/ngage";

// Types ----

type DeleteAchievementProps = {
  achievement: Achievement | null
  show: boolean
  onDelete?: (achievement: Achievement) => any
  onDeleteFail?: (achievement: Achievement, error: unknown) => any
  onCancel?: () => any
}

// Component ----

function DeleteAchievement({achievement, onCancel, onDelete, onDeleteFail, show}: DeleteAchievementProps) {

  const [name, setName] = useState<string>(achievement?.name || 'this achievement');
  const {mutateAsync: deleteAchievement} = useMutation(ngage.achievements.destroy);

  const {notify} = useNotifications();

  useEffect(() => {
    if (achievement) setName(achievement.name)
  }, [achievement]);

  async function handleDeleteAchievement() {
    if (achievement) {
      try {
        await deleteAchievement(achievement.id);
        await invalidate('achievements.all');

        notify("success", "Achievement Deleted", `${achievement.name} has been permanently removed`);
        if (onDelete) onDelete(achievement)
      } catch (error) {
        notify("error", "Achievement Not Deleted", `${achievement.name} could not be removed`);
        if (onDeleteFail) onDeleteFail(achievement, error)
      }
    }
  }

  function handleCancel() {
    if (onCancel) onCancel()
  }

  return (
    <ConfirmModal
      show={show}
      type={ConfirmModal.types.DANGER}
      title="Delete Achievement"
      body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
      approveLabel="Delete"
      onApprove={handleDeleteAchievement}
      onCancel={handleCancel}
    />
  );
}

export default DeleteAchievement;